<template>
	<div>
		<goal-status-report v-if="name==='GoalStatusReport' && hasAccess('GoalStatusReport')" />
		<compliance-report v-else-if="name==='ComplianceReport' && hasAccess('ComplianceReport')" />
		<performance-values-report v-else-if="name==='PerformanceValuesReport' && hasAccess('PerformanceValuesReport')" />
		<employee-compliance-reminders-sent-report v-else-if="name==='EmployeeComplianceRemindersSentReport' && hasAccess('EmployeeComplianceRemindersSentReport')" />
		<div v-else>You do not have access to this report</div>
	</div>
</template>

<script>
	import { mapGetters, mapState } from 'vuex';

	// Reports
	import GoalStatusReport from '@/components/reports/GoalStatusReport';
	import ComplianceReport from '@/components/reports/ComplianceReport';
	import PerformanceValuesReport from '@/components/reports/PerformanceValuesReport';
	import EmployeeComplianceRemindersSentReport from '@/components/reports/EmployeeComplianceRemindersSentReport';

	export default {
		props: {
			name: {
				required: true
			}
		},
		components: {
			GoalStatusReport,
			ComplianceReport,
			PerformanceValuesReport,
			EmployeeComplianceRemindersSentReport
		},
		data() {
			return {};
		},
		created() {
			this.$store.dispatch('setPageTitle', this.getFriendlyName(this.name));
		},
		computed: {
			...mapState({
				reports: state => state.reports.reports 
			}),
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			})
		},
		methods: {
			getFriendlyName(name) {
				const foundReport = this.reports.find(x => x.name === name);
				if(foundReport)
					return foundReport.friendlyName;
				else
					return 'Report';
			}, 
			hasAccess(name) {
				const foundReport = this.reports.find(x => x.name === name);
				if(foundReport) {
					// Improve this logic in the future
					if(foundReport.roles != null && !this.loggedInEmployee.isAdmin) {
						return false;
					} else {
						return true;
					}
				}

				return false;
			}
		}
	};
</script>

<style></style>
